import { RouteProps } from 'react-router-dom'

export type Route = RouteProps & {
    uid?: string
    routes?: Route[]
    exact?: boolean
}

export type Routes = Route[]

export enum ROUTES_IDS {
    HOME = 'HOME',
    ADMIN = 'ADMIN',
    BLOG = 'BLOG',
    DETAILED_BLOG = 'DETAILED_BLOG',
    BUILD_PROJECT = 'BUILD_PROJECT',
    TEAM = 'TEAM',
    SUCCESS_STORIES = 'SUCCESS_STORIES',
    DETAILED_SUCCESS = 'DETAILED_SUCCESS',
    SERVICES = 'SERVICES',
    DETAILED_PROFILE = 'DETAILED_PROFILE',
    WERE_HIRING = 'WERE_HIRING',
    DETAILED_WERE = 'DETAILED_WERE',
    BOOK_A_CALL = 'BOOK_A_CALL',
}

export enum ROUTES {
    HOME = 'home',
    ADMIN = 'admin',
    BLOG = 'blog',
    DETAILED_BLOG = 'detailedBlog',
    BUILD_PROJECT = 'buildProject',
    TEAM = 'team',
    SUCCESS_STORIES = 'successStories',
    DETAILED_SUCCESS = 'detailedSuccess',
    SERVICES = 'services',
    DETAILED_PROFILE = 'detailedProfile',
    WERE_HIRING = 'wereHiring',
    DETAILED_WERE = 'detailedWere',
    BOOK_A_CALL = 'bookACall',
}
